import type { PracticeAgentReportData, PracticeAgentVisualizationType } from '../../types'
import { BarViz } from './BarViz'
import { DonutViz } from '../../../dashboard-builder/DonutViz'
import { LineViz } from './LineViz'
import { GroupedBarViz } from './GroupedBarViz'
import { TableViz } from './TableViz'
import { KpiViz } from './KpiViz'

export function ReportVisualization({
  data,
  vizType,
  onSelect,
  onPageChange,
  onGroupByChange,
  isGroup,
  sortColumn,
  mode = 'workspace',
}: {
  data: PracticeAgentReportData
  vizType: PracticeAgentVisualizationType
  onSelect?: (field: string, value: string) => void
  onPageChange?: (p: number) => void
  onGroupByChange?: (dim: string) => void
  isGroup?: boolean
  sortColumn?: string | null
  mode?: 'workspace' | 'dashboard'
}) {
  switch (vizType) {
    case 'Bar': return <BarViz data={data} onSelect={onSelect} onPageChange={onPageChange} onGroupByChange={onGroupByChange} sortColumn={sortColumn} />
    case 'Donut': return <DonutViz data={data} onSelect={onSelect} />
    case 'GroupedBar': return <GroupedBarViz data={data} onSelect={onSelect} onPageChange={onPageChange} onGroupByChange={onGroupByChange} />
    case 'Line': return <LineViz data={data} onSelect={onSelect} onPageChange={onPageChange} onGroupByChange={onGroupByChange} />
    case 'KPI': return <KpiViz data={data} onSelect={onSelect} onPageChange={onPageChange} isGroup={isGroup} mode={mode} />
    case 'Table': return <TableViz data={data} onSelect={onSelect} onPageChange={onPageChange} />
    default: return <TableViz data={data} onSelect={onSelect} onPageChange={onPageChange} />
  }
}
